import React, { useEffect, useState } from "react";
import "./Home.css";
import Header from "../../componentes/header/Header";
import { NewHome2 } from "./NewHome2";
import { apiGet } from '../../utils/api';
import { configShop } from '../../states/configShop';
import { useLocation } from "react-router-dom";
import PopupNew from "../../componentes/Popup/PopupNew";
import TarjetaSellos from "../Fidelizacion/TarjetaSellos";
export const NewHome = () => {
  const location = useLocation();
  const url = window.location.origin + location.pathname;
  const { dataConfig } = configShop();
  //
  const [showSplash, setShowSplash] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState("#00000000");
  const [imagenHead, setImagenHead] = useState(null);
  const [errorStatus, setErrorStatus] = useState("error");
  const [buttons, setButtons] = useState([]);
  const [social, setSocial] = useState([]);
  const [properties, setProperties] = useState([]);
  ////
  const [popUp, setPopUp] = useState([]);

  const obtenerListaTiendas = async () => {
    const respuesta = await apiGet('/app');
    setErrorStatus(respuesta.success);
    if (respuesta.success === "success") {
      setProperties(respuesta.properties);
      setImagenHead(respuesta.properties.img_home);
      localStorage.removeItem("infoProductoSeleccionado");
      localStorage.removeItem("uuidShop");
      localStorage.removeItem("typeSend");
      localStorage.setItem("colorBoton", respuesta.properties.color_botton);
      localStorage.setItem("colorHover", respuesta.properties.color_hover);
      setButtons(respuesta.data);
      setSocial(respuesta.data.social)
      // setPopupStatus(respuesta.properties.popUps.popupHome.status)
      setPopUp(respuesta.properties.popUps.popupHome);
      ////
      console.log("popUp", popUp.img);
    }
  };

  useEffect(() => {
    obtenerListaTiendas();
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
      document.body.style.background = "";
    }, 2000);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  const handleShare = async () => {
    try {
      await navigator.share({
        title: dataConfig?.title_home,
        text: dataConfig?.description_home,
        url: url,
      });
    } catch (err) {
      console.log("Compartir cancelado o no soportado", err);
    }
  };
  if (!properties?.page_home) {
    return (
      <div className="dynamic-bg-wrapper">
        <div className="dynamic-bg-image" style={{ backgroundImage: `url(${imagenHead})` }} />
        <div className="overlay-content d-flex align-items-center justify-content-center">
          <div className="spinner-border text-light" role="status" />
        </div>
      </div>
    );
  }
  const bgType = Number(properties.page_home.background_type);

  return (
    <div
      className="dynamic-bg-wrapper"
      style={bgType === 1 ? { backgroundColor: properties.page_home.color_background } : undefined}
    >
      {bgType === 2 && (
        <>
          <div
            className="dynamic-bg-image"
            style={{ backgroundImage: `url(${properties.page_home.background_image})` }}
          />
          <div className="dynamic-bg-overlay" />
        </>
      )}
      <div className="overlay-content text-white text-center">
        <Header
          properties={properties}
        />
        <div className="container py-5">
          <div className="row">
            <div className="col-12 col-md-6 home">
              <h1 className="mb-4 text-center color-text" style={{ "--btn-font-color": properties?.page_home?.color_subtitle }}>
                {properties?.page_home?.subtitle}
              </h1>
              <p className="color-text" style={{ "--btn-font-color": properties?.page_home?.color_subtitle_description }} >{properties?.page_home?.subtitle_description}</p>
              {/* PLZ-304: tarjeta de sellos del comercio (con el ultimo pedido de este telefono, si hay) */}
              <TarjetaSellos serviceId={(() => { try { return localStorage.getItem("pleiztService"); } catch (e) { return null; } })()} />
            </div>
            <div className="col-12 col-md-6 button">
              <NewHome2
                backgroundColor={backgroundColor}
                imagenHead={imagenHead}
                statusButtons={buttons}
                socialButtons={social}
              ></NewHome2>

            </div>
          </div>
        </div>
        <PopupNew TimeMoments={'PopUpHome'} popUps={popUp} />
        {/* Footer */}
        <footer
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            background: dataConfig?.page_home?.footer_background,
            color:  dataConfig?.page_home?.footer_color,
            textAlign: "center",
            padding: "10px 0",
            zIndex: 1000
          }}
        >
          <a
            href="https://sealky.co"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: dataConfig?.color_button_text, textDecoration: "none" }}
          >
            {new Date().getFullYear()} Hecho con ❤️ y mucho sabor · sealky.co
          </a>
        </footer>
      </div>
    </div>
  );
};
